export class basketVM {
  bookpage: string;
 // page: string;
  pageCount: number;
  isEmail: boolean;
  emailAs: string;
  isDownload: boolean;
  downloadAs: string;
  includeDetail: boolean;
  docType: string;
  isPDF: boolean;
  isTIF: boolean;
  wholeDoc: boolean;
  //book: string;
  //page: string;
  pages: Array<string>;
  beginBook: string | undefined;
  beginPage: string | undefined;
  begindocnum: string | undefined;
  docId: string;
  dept: string;

}
